import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FiHome, FiFolderPlus, FiFile, FiPackage, FiKey, FiSearch, FiBook, FiGlobe, FiX, FiUser, FiLogOut, FiHeart, FiSettings } from 'react-icons/fi';
import { useAuth } from '../AuthContext';

function Sidebar({ isOpen, onClose }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  console.log('Sidebar render - isOpen:', isOpen, 'user:', user);

  const isActive = (path) => location.pathname === path;

  const handleLogout = async () => {
    await logout();
    onClose();
    navigate('/login');
  };

  // Lock body scroll when sidebar is open on mobile
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  // Close sidebar when route changes (only if open)
  useEffect(() => {
    if (isOpen) {
      onClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <>
      {/* Overlay */}
      {isOpen && <div className="sidebar-overlay" onClick={onClose} aria-hidden="true"></div>}

      {/* Sidebar */}
      <aside className={`sidebar ${isOpen ? 'sidebar-open' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-user-info">
            <FiUser className="user-icon" />
            <div>
              <div className="user-name">{user?.username}</div>
              <div className="user-email">{user?.email}</div>
            </div>
          </div>
          <button className="sidebar-close" onClick={onClose} aria-label="Close menu">
            <FiX />
          </button>
        </div>
        <nav className="sidebar-nav">
          <Link 
            to="/dashboard" 
            className={`sidebar-link ${isActive('/dashboard') ? 'active' : ''}`}
            onClick={onClose}
          >
            <FiHome className="sidebar-icon" />
            <span>Dashboard</span>
          </Link>
          <Link 
            to="/projects" 
            className={`sidebar-link ${isActive('/projects') ? 'active' : ''}`}
            onClick={onClose}
          >
            <FiFolderPlus className="sidebar-icon" />
            <span>My Projects</span>
          </Link>
          <Link 
            to="/my-files" 
            className={`sidebar-link ${isActive('/my-files') ? 'active' : ''}`}
            onClick={onClose}
          >
            <FiFile className="sidebar-icon" />
            <span>My Files</span>
          </Link>
          <Link 
            to="/backed-projects" 
            className={`sidebar-link ${isActive('/backed-projects') ? 'active' : ''}`}
            onClick={onClose}
          >
            <FiHeart className="sidebar-icon" />
            <span>Backed Projects</span>
          </Link>
          <Link 
            to="/apk-builds" 
            className={`sidebar-link ${isActive('/apk-builds') ? 'active' : ''}`}
            onClick={onClose}
          >
            <FiPackage className="sidebar-icon" />
            <span>Builds</span>
          </Link>
          <Link 
            to="/api-keys" 
            className={`sidebar-link ${isActive('/api-keys') ? 'active' : ''}`}
            onClick={onClose}
          >
            <FiKey className="sidebar-icon" />
            <span>API Keys</span>
          </Link>
          <Link 
            to="/browse" 
            className={`sidebar-link ${isActive('/browse') ? 'active' : ''}`}
            onClick={onClose}
          >
            <FiSearch className="sidebar-icon" />
            <span>Browse</span>
          </Link>
          <Link 
            to="/docs" 
            className={`sidebar-link ${isActive('/docs') ? 'active' : ''}`}
            onClick={onClose}
          >
            <FiBook className="sidebar-icon" />
            <span>API Docs</span>
          </Link>
          <Link 
            to="/static-sites" 
            className={`sidebar-link ${isActive('/static-sites') ? 'active' : ''}`}
            onClick={onClose}
          >
            <FiGlobe className="sidebar-icon" />
            <span>Static Sites</span>
          </Link>
          
          {/* Admin Link - Only show for admin users */}
          {user?.is_admin && (
            <Link 
              to="/admin" 
              className={`sidebar-link ${isActive('/admin') ? 'active' : ''}`}
              onClick={onClose}
            >
              <FiSettings className="sidebar-icon" />
              <span>Admin</span>
            </Link>
          )}
          
          <div className="sidebar-divider"></div>
          
          <Link 
            to="/login"
            className="sidebar-link"
            onClick={(e) => { e.preventDefault(); handleLogout(); }}
          >
            <FiLogOut className="sidebar-icon" />
            <span>Logout</span>
          </Link>
        </nav>
      </aside>
    </>
  );
}

export default Sidebar;
